import { render } from "./ModalNuevo.vue?vue&type=template&id=0477dadf"
import script from "./ModalNuevo.vue?vue&type=script&lang=js"
export * from "./ModalNuevo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__